/* batida-v7-search.js: suggestions under the header's search on batida.pl (Aleksandra 29.09).
   Markup: snippets/search-predictive.liquid (the popdown and the phone menu's search, both marked [data-v7-search]);
   look: assets/batida-v7-search.css. The theme's popdown (open / close / focus trap / scroll lock) is untouched.
   From 2 letters, 150 ms after the last key: Shopify's Predictive Search (/search/suggest.json: products, collections,
   pages) AND the theme's own index (/search?view=search-index, templates/search.search-index.liquid, cached in
   sessionStorage) matched with Polish marks ignored on both sides (lowercase, NFD without combining marks, ł -> l), so
   "mil" finds "Miłości" and "zurek" finds "Żurek". Merged by url: matches at the start of a word first, then inside a
   word, then whatever else Shopify ranked (its body-text hits); Shopify's order before the index's. Typed letters are
   bold in the original text. Keyboard: ↑ ↓ move (combobox / listbox / option, aria-activedescendant), Enter opens the
   highlighted item (or submits the search), Esc closes the list (the second Esc closes the search - the theme's).
   Bottom: "Zobacz wszystkie wyniki dla „…”" -> /search?q=…; nothing found: a note + the bestsellers from the index.
   Texts: locale keys batida.v7.search_* (printed as data-t-* on the wrapper). */
(function () {
  'use strict';
  if (window.__v7sLoaded) return;
  window.__v7sLoaded = true;
  var MAP = { 'ł': 'l', 'Ł': 'l' };
  function foldChar(c) { if (MAP[c]) return MAP[c]; return c.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); }
  /* {n: folded text, map: the original index of every folded character} */
  function fold(s) {
    s = String(s == null ? '' : s);
    var n = '', map = [];
    for (var i = 0; i < s.length; i++) { var f = foldChar(s.charAt(i)); for (var j = 0; j < f.length; j++) { n += f.charAt(j); map.push(i); } }
    return { n: n, map: map };
  }
  function norm(s) { return fold(s).n.replace(/\s+/g, ' ').trim(); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function mark(text, qn) {
    text = String(text == null ? '' : text);
    var f = fold(text), i = qn ? f.n.indexOf(qn) : -1;
    if (i < 0) return esc(text);
    var a = f.map[i], b = f.map[i + qn.length - 1] + 1;
    return esc(text.slice(0, a)) + '<b>' + esc(text.slice(a, b)) + '</b>' + esc(text.slice(b));
  }
  function money(c) { if (window.batidaMoney) return window.batidaMoney(c); return ((c || 0) / 100).toFixed(2).replace('.', ',') + ' zł'; }
  function cents(s) { if (s == null || s === '') return null; var v = Math.round(parseFloat(String(s).replace(',', '.')) * 100); return isNaN(v) ? null : v; }
  function thumb(u, w) { if (!u) return ''; u = String(u); if (u.indexOf('cdn.shop') < 0) return u; return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + (w || 120); }
  function path(u) { return String(u || '').split('?')[0].split('#')[0]; }
  /* 0 = a word starts with the letters, 1 = the letters inside a word, 2 = no match in the title (Shopify's body hit) */
  function rank(title, qn) { var n = norm(title); if ((' ' + n).indexOf(' ' + qn) >= 0) return 0; if (n.indexOf(qn) >= 0) return 1; return 2; }

  var indexP = null;
  function loadIndex(cfg) {
    if (indexP) return indexP;
    var key = 'v7s-index:' + cfg.index;
    try { var c = sessionStorage.getItem(key); if (c) { var o = JSON.parse(c); if (o && o.v === 2 && o.products) { indexP = Promise.resolve(o); return indexP; } } } catch (e) {}
    indexP = fetch(cfg.index, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); }).then(function (t) {
      var o = JSON.parse(t.trim());
      if (!o || !o.products) throw new Error('index');
      try { sessionStorage.setItem(key, JSON.stringify(o)); } catch (e) {}
      return o;
    }).catch(function () { indexP = null; return { products: [], collections: [], pages: [], best: [] }; });
    return indexP;
  }
  function suggest(cfg, q, signal) {
    var u = cfg.suggest + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=' + cfg.limit +
      '&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title';
    return fetch(u, { credentials: 'same-origin', signal: signal }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      var r = (d && d.resources && d.resources.results) || {};
      return { products: r.products || [], collections: r.collections || [], pages: r.pages || [] };
    }).catch(function () { return { products: [], collections: [], pages: [] }; });
  }
  function merge(api, idx, qn, cfg) {
    function pick(apiList, idxList, mapApi, mapIdx, cap) {
      var out = [], seen = {}, n = 0;
      function add(item, src) { var k = path(item.url); if (!k || seen[k]) return; seen[k] = 1; item.r = rank(item.title, qn); item.src = src; item.i = n++; out.push(item); }
      (apiList || []).forEach(function (x) { add(mapApi(x), 0); });
      (idxList || []).forEach(function (x) { var it = mapIdx(x); if (rank(it.title, qn) < 2) add(it, 1); });
      out.sort(function (a, b) { return (a.r - b.r) || (a.src - b.src) || (a.i - b.i); });
      return out.slice(0, cap);
    }
    /* category + time ("Ciasta i torty · 24 h") come from the index (30.09); Shopify's own hits borrow them by url */
    var byUrl = {};
    (idx.products || []).forEach(function (x) { byUrl[path(x.u)] = x; });
    function apiProduct(p) {
      var mn = cents(p.price_min != null ? p.price_min : p.price), mx = cents(p.price_max != null ? p.price_max : p.price), ix = byUrl[path(p.url)] || {};
      return { title: p.title, url: p.url, img: thumb(p.image || (p.featured_image && p.featured_image.url)), price: mn, varies: mn != null && mx != null && mx > mn, cat: ix.c || '', h: ix.h || 0 };
    }
    function idxProduct(p) { return { title: p.t, url: p.u, img: p.i, price: p.p, varies: !!p.pv, cat: p.c || '', h: p.h || 0 }; }
    function apiLink(c) { return { title: c.title, url: c.url }; }
    function idxLink(c) { return { title: c.t, url: c.u }; }
    return {
      products: pick(api.products, idx.products, apiProduct, idxProduct, cfg.limit),
      collections: pick(api.collections, idx.collections, apiLink, idxLink, 4),
      pages: pick(api.pages, idx.pages, apiLink, idxLink, 3),
      best: (idx.best || []).slice(0, 4).map(idxProduct)
    };
  }

  function options(st) { return [].slice.call(st.list.querySelectorAll('[role="option"]')); }
  function setActive(st, i) {
    var o = options(st);
    if (!o.length) { st.active = -1; st.input.removeAttribute('aria-activedescendant'); return; }
    if (i < 0) i = o.length - 1; if (i >= o.length) i = 0;
    o.forEach(function (el, k) { var on = k === i; el.setAttribute('aria-selected', on ? 'true' : 'false'); el.classList.toggle('is-active', on); });
    st.active = i;
    st.input.setAttribute('aria-activedescendant', o[i].id);
    try { o[i].scrollIntoView({ block: 'nearest' }); } catch (e) {}
  }
  function close(st) {
    st.list.innerHTML = '';
    st.results.classList.remove('is-open');
    st.input.setAttribute('aria-expanded', 'false');
    st.input.removeAttribute('aria-activedescendant');
    st.active = -1; st.open = false;
  }
  /* before 2 letters: "Popularne:" pills (header setting "Wyszukiwarka: popularne"), not an empty list */
  function popular(st) {
    var terms = st.cfg.popular;
    if (!terms.length) { close(st); return; }
    st.list.innerHTML = '<div class="v7s-pop"><b>' + esc(st.cfg.t.popular) + '</b>' + terms.map(function (w) { return '<a class="v7s-pill" href="' + esc(st.cfg.search + '?q=' + encodeURIComponent(w)) + '">' + esc(w) + '</a>'; }).join('') + '</div>';
    st.results.classList.add('is-open');
    st.input.setAttribute('aria-expanded', 'false');
    st.input.removeAttribute('aria-activedescendant');
    st.active = -1; st.open = false;
  }
  function render(st, res, q, qn) {
    var t = st.cfg.t, n = 0, h = '';
    function opt(cls, href, inner) { var id = st.listId + '-' + (n++); return '<a role="option" id="' + id + '" class="v7s-item ' + cls + '" href="' + esc(href) + '" aria-selected="false" tabindex="-1">' + inner + '</a>'; }
    function prod(p, m) {
      /* a 0 zł product (the custom-cake enquiry) is priced individually, not "0,00 zł" (Aleksandra's audit 30.09) */
      var price = p.price === 0 && !p.varies ? t.quote : p.price != null ? (p.varies ? t.from + ' ' : '') + money(p.price) : '';
      var sub = [p.cat, p.h ? p.h + ' h' : ''].filter(Boolean).join(' · ');
      return opt('v7s-item--product', p.url, '<span class="v7s-img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="52" height="52">' : '') + '</span><span class="v7s-t"><span class="v7s-n">' + (m ? mark(p.title, qn) : esc(p.title)) + '</span>' + (sub ? '<span class="v7s-sub">' + esc(sub) + '</span>' : '') + '</span>' + (price ? '<span class="v7s-p">' + esc(price) + '</span>' : ''));
    }
    function link(c) { return opt('v7s-item--link', c.url, '<span class="v7s-t">' + mark(c.title, qn) + '</span>'); }
    var count = res.products.length + res.collections.length + res.pages.length;
    /* 30.09 (Aleksandra, the approved search): products on the left (+ "Zobacz wszystkie wyniki" under them),
       categories and pages on the right; nothing found = a note + the bestsellers */
    var left = '', right = '';
    if (res.products.length) left += '<div class="v7s-group"><p class="v7s-h">' + esc(t.products) + '</p>' + res.products.map(function (p) { return prod(p, true); }).join('') + '</div>';
    if (res.collections.length) right += '<div class="v7s-group v7s-group--links"><p class="v7s-h">' + esc(t.collections) + '</p>' + res.collections.map(link).join('') + '</div>';
    if (res.pages.length) right += '<div class="v7s-group v7s-group--links"><p class="v7s-h">' + esc(t.pages) + '</p>' + res.pages.map(link).join('') + '</div>';
    if (!count) {
      left += '<p class="v7s-none">' + esc(t.none) + '</p>';
      if (res.best.length) left += '<div class="v7s-group">' + res.best.map(function (p) { return prod(p, false); }).join('') + '</div>';
    }
    left += opt('v7s-all', st.cfg.search + '?q=' + encodeURIComponent(q), '<span class="v7s-t">' + esc(t.all).replace('[q]', esc(q)) + ' →</span>');
    h = '<div class="v7s-cols' + (right ? '' : ' v7s-cols--one') + '"><div class="v7s-col">' + left + '</div>' + (right ? '<div class="v7s-col v7s-col--links">' + right + '</div>' : '') + '</div>';
    st.list.innerHTML = h;
    st.results.classList.add('is-open');
    st.input.setAttribute('aria-expanded', 'true');
    st.active = -1; st.open = true;
    st.input.removeAttribute('aria-activedescendant');
    if (st.status) st.status.textContent = t.status.replace('[n]', String(count));
  }
  function run(st, q) {
    var qn = norm(q), seq = ++st.seq, key = q.toLowerCase();
    if (st.ctl) { try { st.ctl.abort(); } catch (e) {} }
    st.ctl = window.AbortController ? new AbortController() : null;
    var apiP = st.cache[key] ? Promise.resolve(st.cache[key]) : suggest(st.cfg, q, st.ctl && st.ctl.signal).then(function (r) { st.cache[key] = r; return r; });
    Promise.all([apiP, loadIndex(st.cfg)]).then(function (a) {
      if (seq !== st.seq) return;
      render(st, merge(a[0], a[1], qn, st.cfg), q, qn);
    });
  }
  function onInput(st) {
    var q = st.input.value.trim();
    if (st.reset) st.reset.classList.toggle('is-hidden', !q);
    clearTimeout(st.timer);
    if (norm(q).length < st.cfg.min) { st.seq++; if (st.ctl) { try { st.ctl.abort(); } catch (e) {} } popular(st); return; }
    st.timer = setTimeout(function () { run(st, q); }, 150);
  }
  function init(root) {
    if (root.__v7s) return;
    root.__v7s = true;
    var input = root.querySelector('[data-predictive-search-input]'), results = root.querySelector('[data-v7s-results]'), list = root.querySelector('[data-v7s-list]');
    if (!input || !results || !list) return;
    var d = root.dataset;
    var st = {
      input: input, results: results, list: list, reset: root.querySelector('.search-reset'), status: root.querySelector('[data-v7s-status]'),
      listId: list.id, cache: {}, seq: 0, timer: null, ctl: null, active: -1, open: false, swallow: false,
      cfg: {
        suggest: d.suggest, index: d.index, search: d.search, min: parseInt(d.min, 10) || 2, limit: parseInt(d.limit, 10) || 6,
        t: { products: d.tProducts || 'Produkty', collections: d.tCollections || 'Kategorie', pages: d.tPages || 'Strony', all: d.tAll || 'Zobacz wszystkie wyniki dla „[q]”', none: d.tNone || 'Nic nie znaleźliśmy - zobacz bestsellery', status: d.tStatus || 'Podpowiedzi: [n]', from: d.tFrom || 'od', quote: d.tQuote || 'wycena indywidualna', popular: d.tPopular || 'Popularne:' },
        popular: String(d.popular || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean)
      }
    };
    root.__v7st = st;
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', list.id);
    input.setAttribute('autocomplete', 'off');
    input.addEventListener('input', function () { onInput(st); });
    input.addEventListener('focus', function () { if (!st.open) onInput(st); loadIndex(st.cfg); });
    input.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowDown' || k === 'ArrowUp') { if (!st.open) return; e.preventDefault(); setActive(st, st.active + (k === 'ArrowDown' ? 1 : -1)); }
      else if (k === 'Enter') {
        var o = options(st);
        if (st.open && st.active >= 0 && o[st.active]) { e.preventDefault(); window.location.href = o[st.active].href; }
        else if (!input.value.trim()) e.preventDefault();
      }
      else if (k === 'Escape' || k === 'Esc') { /* 30.09: Esc closes the whole search (the theme's keyup handler) */ }
      else if (k === 'Home' && st.open && st.active >= 0) { e.preventDefault(); setActive(st, 0); }
      else if (k === 'End' && st.open && st.active >= 0) { e.preventDefault(); setActive(st, options(st).length - 1); }
    });
    /* the theme closes the whole search on keyup Escape: the first Esc only closes the list */
    input.addEventListener('keyup', function (e) { if ((e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) && st.swallow) { st.swallow = false; e.stopPropagation(); } });
    list.addEventListener('mousemove', function (e) { var el = e.target.closest && e.target.closest('[role="option"]'); if (el) { var i = options(st).indexOf(el); if (i !== st.active) setActive(st, i); } });
    if (st.reset) st.reset.addEventListener('click', function () { setTimeout(function () { input.value = ''; onInput(st); input.focus(); }, 0); });
    var form = input.form;
    if (form) form.addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });
  }
  /* 30.09 (Aleksandra): on the desktop the search opens as a bar under the whole header (every width since 1.10) - logo and menu stay visible,
     the rest of the page is dimmed. The theme's popdown is fixed at the top; its top (and the dim's) is set to the
     header's bottom edge each time it opens (the header moves with the announcement bar and when it sticks). */
  function placeUnderHeader() {
    var hd = document.querySelector('.theme__header .header__inner') || document.querySelector('.theme__header');
    var pd = document.querySelector('.search-popdown'); if (!hd || !pd) return;
    var y = Math.max(0, Math.round(hd.getBoundingClientRect().bottom));
    pd.style.setProperty('--v7s-top', y + 'px');
    document.documentElement.style.setProperty('--v7s-top', y + 'px');
    pd.classList.add('v7s-under');
    var root = pd.querySelector('[data-v7-search]');
    if (root && root.__v7st) { root.__v7st.input.value = ''; popular(root.__v7st); }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-popdown-toggle="search-popdown"]');
    if (t) placeUnderHeader();
  }, true);
  function boot() { [].slice.call(document.querySelectorAll('[data-v7-search]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
